












































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { DxAutocomplete } from 'devextreme-vue';
import Card from '@/components/default/Card.vue';
import notificationService from '@/services/notificationService';
import projectsRepository from '@/services/projectsRepository';
import dxCustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { DxForm, DxSimpleItem, DxRequiredRule, DxGroupItem, DxLabel } from 'devextreme-vue/form';

import { ContactsClient, DataSourceLoadOptionsBase, ContactsLookupQuery, ProjectsClient, ProgressStatementStatus, ProgressStatement } from '@/data/web-api-client';
import _ from 'lodash';

@Component({
  components: {
    Card,
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxLabel,
    DxAutocomplete,
  },
})
export default class ProgressStatementDetailsCard extends Vue {
  @Prop({ required: true })
  progressStatement!: ProgressStatement;

  @Prop({ required: true })
  saving: boolean = false;

  @Prop({ required: false, default: false })
  disabled!: boolean;

  editMode: boolean = false;

  toggleEditMode() {
    this.editMode = !this.editMode;
  }

  save() {
    const form: any = this.$refs.statementForm;
    const validationResult = form.instance.validate();
    if (validationResult.isValid) {
      this.$emit('updated');
      this.editMode = false;
    } else {
      notificationService.invalidForm();
    }
  }

  get projectsOptions() {
    const self = this;
    return {
      dataSource: new DataSource({
        store: new dxCustomStore({
          key: 'id',
          load: async (loadOptions) => {
            if (Array.isArray(loadOptions.filter) && loadOptions.filter.length > 1 && loadOptions.filter[0] === 'id') {
              return {
                data: [],
                totalCount: 0,
              };
            }
            if (loadOptions.searchExpr && loadOptions.searchValue && loadOptions.searchOperation) {
              loadOptions.filter = [loadOptions.searchExpr, loadOptions.searchOperation, loadOptions.searchValue];
            }
            const result = await projectsRepository.lookup(loadOptions);
            return {
              data: result.data.data,
              totalCount: result.data.totalCount,
            };
          },
          byKey: async (val: any) => {
            const client = new ProjectsClient(undefined, this.$axios);
            return await client.getProjectBasicInfo(val);
          },
        }),
        paginate: true,
      }),
      valueExpr: 'id',
      displayExpr: 'name',
      searchExpr: 'name',
      searchEnabled: true,
      disabled: true,
      showClearButton: false,
    };
  }

  get versionNumberOptions() {
    return {
      dataSource: _.range(1, 11),
      disabled: !this.editMode,
    };
  }

  get statementStatusses() {
    return [
      { value: ProgressStatementStatus.Draft, text: 'Klad' },
      { value: ProgressStatementStatus.Open, text: 'Open' },
      { value: ProgressStatementStatus.Send, text: 'Verstuurd' },
      { value: ProgressStatementStatus.Approved, text: 'Aanvaard' },
      { value: ProgressStatementStatus.Declined, text: 'Afgewezen' },
      { value: ProgressStatementStatus.Replaced, text: 'Vervangen' },
      { value: ProgressStatementStatus.Invoiced, text: 'Gefactureerd' },
    ];
  }

  get workTypesOptions() {
    const catalog = this.$store.getters['catalogs/list']('WorkTypes');
    const values = catalog ? catalog.values : [];

    return {
      items: values,
      disabled: this.disabledWhenSend,
    };
  }

  get disabledWhenSend() {
    return this.progressStatement.status! > ProgressStatementStatus.Open || !this.editMode;
  }

  get contactsOptions() {
    const self = this;
    const client = new ContactsClient(undefined, this.$axios);
    return {
      dataSource: new DataSource({
        store: new dxCustomStore({
          key: 'id',
          load: async (loadOptions) => {
            if (loadOptions.filter) {
              loadOptions.filter = undefined;
            }
            if (loadOptions.searchExpr && loadOptions.searchOperation && loadOptions.searchValue) {
              loadOptions.filter = [['displayName', loadOptions.searchOperation, loadOptions.searchValue], 'or', ['email', loadOptions.searchOperation, loadOptions.searchValue]];
            }

            const res = await client.lookupContacts(
              new ContactsLookupQuery({
                projectId: this.progressStatement.projectId,
                options: new DataSourceLoadOptionsBase(
                  Object.assign({}, loadOptions, {
                    stringToLower: true,
                  })
                ),
              })
            );

            return res;
          },
          byKey: async (val: string) => {
            return await client.getBasicInfo(val);
          },
        }),
        paginate: this.progressStatement.projectId ? false : true,
      }),
      displayExpr: 'displayName',
      searchEnabled: true,
      disabled: self.disabledWhenSend,
      showClearButton: true,
    };
  }
}
